import { Flex } from '@grupoboticario/flora-react';
import {
  BoxIcon,
  DollarSignCircleIcon,
  TruckIcon,
  MagazineIcon,
} from '@grupoboticario/flora-react-icons';

import { ResponsiveFloraTypography } from 'components';

import Styles from './Supervisor.components.styles';
import ProfileComponentsStyles from '../../Profile.components.styles';

export const Info = ({ isFirstOrder }: { isFirstOrder?: boolean }) => {
  return (
    <Flex direction='column' gap='$3'>
      <ProfileComponentsStyles.SubTitle>Entre em contato para:</ProfileComponentsStyles.SubTitle>

      {isFirstOrder ? (
        <Styles.InfoWrapper>
          <Flex align='center' gap='$2'>
            <BoxIcon color='$nonInteractiveAuxiliar' size={16} />
            <ProfileComponentsStyles.SubText>
              Realizar primeiro pedido
            </ProfileComponentsStyles.SubText>
          </Flex>
          <ResponsiveFloraTypography data-divider color='$nonInteractiveAuxiliar'>
            |
          </ResponsiveFloraTypography>
          <Flex align='center' gap='$2'>
            <MagazineIcon color='$nonInteractiveAuxiliar' size={16} />
            <ProfileComponentsStyles.SubText>Dúvidas sobre revenda</ProfileComponentsStyles.SubText>
          </Flex>
          <ResponsiveFloraTypography data-divider color='$nonInteractiveAuxiliar'>
            |
          </ResponsiveFloraTypography>
          <Flex align='center' gap='$2'>
            <DollarSignCircleIcon color='$nonInteractiveAuxiliar' size={16} />
            <ProfileComponentsStyles.SubText>Boletos e pagamentos</ProfileComponentsStyles.SubText>
          </Flex>
        </Styles.InfoWrapper>
      ) : (
        <Styles.InfoWrapper>
          <Flex align='center' gap='$2'>
            <BoxIcon color='$nonInteractiveAuxiliar' size={16} />
            <ProfileComponentsStyles.SubText>
              Dúvidas sobre produtos e pedidos
            </ProfileComponentsStyles.SubText>
          </Flex>
          <ResponsiveFloraTypography data-divider color='$nonInteractiveAuxiliar'>
            |
          </ResponsiveFloraTypography>
          <Flex align='center' gap='$2'>
            <DollarSignCircleIcon color='$nonInteractiveAuxiliar' size={16} />
            <ProfileComponentsStyles.SubText>Boletos e pagamentos</ProfileComponentsStyles.SubText>
          </Flex>
          <ResponsiveFloraTypography data-divider color='$nonInteractiveAuxiliar'>
            |
          </ResponsiveFloraTypography>
          <Flex align='center' gap='$2'>
            <TruckIcon color='$nonInteractiveAuxiliar' size={16} />
            <ProfileComponentsStyles.SubText>Entrega e pós-compra</ProfileComponentsStyles.SubText>
          </Flex>
        </Styles.InfoWrapper>
      )}
    </Flex>
  );
};
